module.exports = __webpack_public_path__ + "img/tile-oth2.ae341256.jpg";